module.exports = __webpack_public_path__ + "img/g-loading-1.db36c831.gif";